<template>
    <div class="DesignExamplesIndex">
        <header class="DesignExamplesIndex__header">
            <h1 class="DesignExamplesIndex__title">
                Design Examples
            </h1>
            <p class="DesignExamplesIndex__subtitle">
                Standalone UI examples (EvidentID staff only)
            </p>
        </header>
        <nav class="DesignExamplesIndex__nav">
            <router-link :to="{ name: 'examples.colors' }" class="DesignExamplesIndex__card">
                <span class="DesignExamplesIndex__cardTitle">Colors</span>
                <span class="DesignExamplesIndex__cardDesc">Color palette and CSS variables</span>
            </router-link>
            <router-link :to="{ name: 'examples.components.badges' }" class="DesignExamplesIndex__card">
                <span class="DesignExamplesIndex__cardTitle">Components</span>
                <span class="DesignExamplesIndex__cardDesc">Buttons, labels, modals and more</span>
            </router-link>
        </nav>
    </div>
</template>

<style lang="scss" scoped>
.DesignExamplesIndex {
    min-height: 100vh;
    padding: 2rem;
    background: var(--eidTechGray-10);

    &__header {
        margin-bottom: 2rem;
    }

    &__title {
        margin: 0 0 0.25rem;
        font-size: 1.5rem;
        font-weight: 600;
        color: var(--eidTechGray);
    }

    &__subtitle {
        margin: 0;
        font-size: 0.875rem;
        color: var(--eidTechGray-75);
    }

    &__nav {
        display: flex;
        gap: 1rem;
    }

    &__card {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        padding: 1.5rem;
        width: 200px;
        background: #fff;
        border-radius: 0.5rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        text-decoration: none;
        transition: box-shadow 0.15s;

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        }
    }

    &__cardTitle {
        font-size: 1rem;
        font-weight: 600;
        color: var(--eidSecureBlue);
    }

    &__cardDesc {
        font-size: 0.8rem;
        color: var(--eidTechGray-75);
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'DesignExamplesIndex',
    });
</script>
